import styled from "styled-components"
import { BREAKPOINTS, colors } from "@/styles/themeSettings"
import { getCssSizeValue, getHtmlFromRedactorField, getIdWithoutSpecialSymbols, getItemUrl } from "@/utils/utils"
import Text from "@/components/common/Text"
import useHover from "@/hooks/useHover"
import SimpleIconButton, { SIMPLE_ICON_BUTTON_CLASS_NAME } from "@/components/common/SimpleIconButton"
import { useRouter } from "next/router"

const EmblaSlide = styled.div`
	--bg-color: #0e2c54;
	--color: ${({ theme }) => theme.colors.white};

	background: var(--bg-color);
	color: var(--color);

	position: relative;
	display: flex;
	flex: 0 0 100%;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	aspect-ratio: 1;
	transition: all var(--rgr-duration) var(--ease);

	&:nth-child(even) {
		translate: 0 100%;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		user-select: none;
		cursor: pointer;
		padding: ${getCssSizeValue(15, BREAKPOINTS.TABLET)} ${getCssSizeValue(110, BREAKPOINTS.TABLET)}
			${getCssSizeValue(20, BREAKPOINTS.TABLET)} ${getCssSizeValue(42, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		flex: 0 0 20%;
		padding: 0 ${getCssSizeValue(24)};
	}

	&.highlighted {
		--bg-color: ${({ theme }) => theme.colors.chilliRed};
	}

	&.hovered {
		--bg-color: ${({ theme }) => theme.colors.periwinkle};
		--color: ${({ theme }) => theme.colors.richBlack};
	}

	.${SIMPLE_ICON_BUTTON_CLASS_NAME} {
		position: absolute;
		top: 0;
		right: 0;
		opacity: 0;

		&.hovered {
			opacity: 1;
		}
	}
`

const NumberBadge = styled.div`
	position: absolute;
	display: grid;
	place-items: center;
	top: 0;
	right: 0;
	color: ${({ theme }) => theme.colors.richBlack};
	background: ${({ theme }) => theme.colors.platinum};
	opacity: 1;
	height: ${getCssSizeValue(40)};
	width: ${getCssSizeValue(40)};
	transition: all var(--rgr-duration) var(--ease);

	&.hovered {
		opacity: 0;
	}
`

function getData(src) {
	return {
		id: getIdWithoutSpecialSymbols(src?.id || ""),
		number: src?.number || "",
		snippet: src?.snippet || "",
		highlighted: src?.highlighted,
	}
}

export default function Tile({ item }) {
	const router = useRouter()
	const { id, number, snippet, highlighted } = getData(item)
	const [ref, isHovered] = useHover()
	const url = getItemUrl(item)

	const handleRedirect = () => {
		router.push(url)
	}

	return (
		<EmblaSlide
			id={id}
			className={`${highlighted ? "highlighted " : ""} ${isHovered ? "hovered" : ""}`}
			ref={ref}
			onClick={handleRedirect}
		>
			<SimpleIconButton
				bgColor={colors.chilliRed}
				borderColor={colors.chilliRed}
				rotation={180}
				className={isHovered ? "hovered" : ""}
			/>
			<NumberBadge className={`typo-borna typo-borna-115 ${isHovered ? "hovered" : ""}`}>{number}</NumberBadge>
			<Text className="typo-strawford typo-strawford-67" dangerouslySetInnerHTML={getHtmlFromRedactorField(snippet)} />
		</EmblaSlide>
	)
}
